import client from "./client";
import { Section } from "@/interfaces";

export const getSections = () => client.get<Section[]>("sections");
